// Returns the setting specified from the current users settings
// See all company settings in platform/app/DataObjects/CompanySettings.php
// See all worker settings in platform/app/DataObjects/FreelancerSettings.php
import { computed, ComputedRef } from 'vue'

export const useAccountSettings = (
  setting: string,
): ComputedRef<null | string | boolean | Record<string, any>> =>
  computed(() => currentAccount.settings[setting] ?? null)
